import { TwilioStatusCode } from '@navio/nsdk';
import { FilterOption } from 'noddi-ui-web';
import { SMS_STATUS_OPTIONS } from 'noddi-util';
import { SMS_STATUS_ICON } from '../../../features/SMS/SMSStatusIcon';

export const SMS_STATUS_FILTER_OPTIONS: FilterOption<TwilioStatusCode>[] = SMS_STATUS_OPTIONS.map((option) => ({
  ...option,
  icon: SMS_STATUS_ICON[option.value]
}));
